"use strict";import{IconArrow100 as r}from"../src/elements/IconArrow100.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-icon-arrow100",r);
//# sourceMappingURL=sp-icon-arrow100.js.map
